import { useQuery } from '@apollo/client';

import GET_ORGANIZATION_DATA from './graphql/AdminDashboardOrganizationData.b2b.graphql';
import type {
  AdminDashboardOrganizationData,
  AdminDashboardOrganizationDataVariables,
} from './graphql/types/AdminDashboardOrganizationData';

const useOrganizationData = ({ slug }: { slug: string }) => {
  const { data, loading, error, refetch } = useQuery<
    AdminDashboardOrganizationData,
    AdminDashboardOrganizationDataVariables
  >(GET_ORGANIZATION_DATA, {
    variables: {
      slug,
    },
    context: { clientName: 'b2b' },
  });

  const organizationData = data?.organizationInfo;

  //TODO: Validate canUploadCourses becouse es deprecated in Back
  const hasElevate =
    organizationData?.configuration?.hasStudioAvailable &&
    organizationData?.configuration?.canUploadCourses;

  return { organizationData, loading, error, refetch, hasElevate };
};

export default useOrganizationData;
